import '../css/NavBar.css';
import { NavLink } from "react-router-dom";
import { AppContext } from './context/AppContext';
import { useContext } from 'react';
import { IAuth } from '../interfaces/interface';

function NavBar() {
    const { linksDisable, navBarStatus, login, authorization } = useContext(AppContext);
    const [disableLinks]: string[] = linksDisable
    const [, setIsNavbarOpen] = navBarStatus;
    const [, setIsLogged] = login;
    const [,setAuth]: React.Dispatch<React.SetStateAction<IAuth>>[] = authorization;
    const [auth]: IAuth[] = authorization;


    const clickHandler = (e:any) => {
        setIsNavbarOpen(false)
        if(disableLinks.includes(e.currentTarget.id)){
            e.preventDefault()
        }        
        
    }
    const signOutClickHandler = () => {
        setIsLogged(false)
        setAuth({
            username: "",
            token: "",
            expiresOn: "",
            scope: "",
            header:{
              headers: {
                Authorization: ``
              }
            }
          })
    }
  return (
    <div className="NavBar">
            <div className='nav-bar-top-section'>
                <img className="nav-bar-hoopo-logo" src="/icons/menu-user.png" alt='hoopo logo'/> 
                <span  className='nav-bar-top-section-text'>{auth.username}</span>
            </div>


            <div className='nav-bar-main-section'>
                <div className='nav-bar-header'>
                    <img className="nav-bar-header-symbol" src="/icons/menu-associate.png" alt='venn-diagram'/>
                    <span className='nav-bar-header-text'>Tracker Registration</span>
                </div>
                <div className='associate-section section'>
                    <NavLink
                        className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}
                        to={'/registration-single-tracker'}
                        id='registration-single-tracker'
                        onClick={clickHandler}
                    >
                        <span className='nav-bar-link'>Single tracker</span>
                        <i className="fas fa-chevron-right nav-bar-link-arrow"></i>
                    </NavLink>
                    <NavLink
                        className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}
                        to={'/bulk-registration'}
                        id='bulk-registration'
                        onClick={clickHandler}
                    >
                        <span className='nav-bar-link'>Bulk registration</span>
                        <i className="fas fa-chevron-right nav-bar-link-arrow"></i>
                    </NavLink>
                </div>


                <div className='nav-bar-header'>
                    <img className="nav-bar-header-symbol" src="/icons/menu-associate.png" alt='venn-diagram'/> 
                    <span className='nav-bar-header-text'>Activation and Association</span>
                </div>
                <div className='associate-section section'>
                    <NavLink 
                        className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}
                        to={'/single-tracker-activation'}
                        id='single-tracker-activation'
                        onClick={clickHandler}
                    >
                        <span className='nav-bar-link'>Single Tracker</span>
                        <i className="fas fa-chevron-right nav-bar-link-arrow"></i>
                    </NavLink>
                    {/*<NavLink */}
                    {/*    className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}*/}
                    {/*    to={'/load-sensor'}*/}
                    {/*    id='Load Sensor'*/}
                    {/*    onClick={clickHandler}*/}
                    {/*>*/}
                    {/*    <span className='nav-bar-link'>Load Sensor</span>*/}
                    {/*    <i className="fas fa-chevron-right nav-bar-link-arrow"></i>*/}
                    {/*</NavLink>*/}
                    <NavLink 
                        className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}
                        to={'/bulk-activation'}
                        id='bulk-activation'
                        onClick={clickHandler}
                    >
                        <span className='nav-bar-link'>Bulk activation</span>
                        <i className="fas fa-chevron-right nav-bar-link-arrow"></i>
                    </NavLink>
                </div>


                <div className='nav-bar-header'>
                <img className="nav-bar-header-symbol" src="/icons/menu-manage.png" alt='venn-diagram'/> 
                    <span className='nav-bar-header-text'>Manage</span>
                </div>
                <div className='manage-section section'>
                    <NavLink 
                        className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}
                        to={'/view-edit-asset'}
                        id='View-Edit-Asset'
                        onClick={clickHandler}
                    >
                        <span className='nav-bar-link'>View / Edit Asset</span>
                        <i className="fas fa-chevron-right nav-bar-link-arrow"></i>
                    </NavLink>
                    <NavLink 
                        className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}
                        to={'/replace-batteries'}
                        id='Replace-Batteries'
                        onClick={clickHandler}
                    >
                        <span className='nav-bar-link'>Replace Batteries</span>
                        <i className="fas fa-chevron-right nav-bar-link-arrow"></i>
                    </NavLink>
                    <NavLink 
                        className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}
                        to={'/replace-tracker'}
                        id='Replace-Tracker'
                        onClick={clickHandler}
                    >
                        <span className='nav-bar-link'>Replace Tracker</span>
                        <i className="fas fa-chevron-right nav-bar-link-arrow"></i>
                    </NavLink>
                    <NavLink 
                        className={(navData) => navData.isActive ? 'nav-bar-link-container nav-bar-activ' : 'nav-bar-link-container'}
                        to={'/load-polygons'}
                        id='Load-Polygons'
                        onClick={clickHandler}
                    >
                        <span className='nav-bar-link'>Load Polygons</span>
                        <i className="fas fa-chevron-right nav-bar-link-arrow"></i>
                    </NavLink>
                </div>
            </div>
            <div className='nav-bar-sign-out-div' onClick={signOutClickHandler}>
                <img className="nav-bar-sign-out-img" src="/icons/signout.png" alt='sign out'/> 
                <span className="nav-bar-sign-out-text" >Sign out</span>
            </div>
    </div>
  );
}

export default NavBar;
